import { StandardEvents } from '@shopify/events';

const desktopDrawerQuery = window.matchMedia('(min-width: 990px)');

function cartDrawer() {
  return document.getElementById('cart-drawer');
}

function labelCheckout() {
  document.querySelectorAll('#cart-drawer .cart__checkout-button .button-text').forEach((label) => {
    label.textContent = 'Finaliser la commande';
  });
}

function hydrateCartImages() {
  document.querySelectorAll('#cart-drawer img.cart-items__media-image').forEach((img) => {
    img.loading = 'eager';
    img.decoding = 'async';
    try { img.fetchPriority = 'high'; } catch (_) {}
    img.style.opacity = '1';
    img.style.visibility = 'visible';

    if (!img.complete) {
      const src = img.getAttribute('src');
      const srcset = img.getAttribute('srcset');
      if (srcset) img.setAttribute('srcset', srcset);
      if (src) img.setAttribute('src', src);
    }
  });
}

function resetDrawerScroll() {
  const items = document.querySelector('#cart-drawer .cart-drawer__items');
  if (items) items.scrollTop = 0;
}

function removeCartFromPersistedState() {
  try {
    const ids = (sessionStorage.getItem('theme-drawer-open') || '')
      .split(',')
      .filter(Boolean)
      .filter((id) => id !== 'cart-drawer');

    if (ids.length) sessionStorage.setItem('theme-drawer-open', ids.join(','));
    else sessionStorage.removeItem('theme-drawer-open');
  } catch (_) {}
}

function ensureDesktopBackdrop() {
  let backdrop = document.querySelector('.smi-cart-backdrop');
  if (backdrop) return backdrop;

  backdrop = document.createElement('div');
  backdrop.className = 'smi-cart-backdrop';
  backdrop.setAttribute('aria-hidden', 'true');
  backdrop.addEventListener('click', () => {
    const drawer = cartDrawer();
    if (drawer && typeof drawer.close === 'function') drawer.close();
  });
  document.body.appendChild(backdrop);
  return backdrop;
}

function clearDesktopOverlay() {
  document.documentElement.classList.remove('smi-cart-open');
  document.querySelector('.smi-cart-backdrop')?.remove();
}

function neutralizePageSqueeze() {
  document.querySelector('.page-wrapper')?.classList.remove('page-wrapper--drawer-open');
}

function syncDesktopOverlay() {
  const drawer = cartDrawer();
  const isOpen = Boolean(drawer?.hasAttribute('open'));

  if (isOpen && desktopDrawerQuery.matches) {
    neutralizePageSqueeze();
    document.documentElement.classList.add('smi-cart-open');
    ensureDesktopBackdrop();
    requestAnimationFrame(neutralizePageSqueeze);
  } else {
    clearDesktopOverlay();
  }
}

function hydrateCartUI() {
  const drawer = cartDrawer();
  if (drawer) drawer.setAttribute('no-persist', '');
  removeCartFromPersistedState();
  labelCheckout();
  hydrateCartImages();
  syncDesktopOverlay();
}

async function syncCartUI(event) {
  try {
    const result = event.promise ? await event.promise : null;
    const { cart, detail } = result || {};

    requestAnimationFrame(() => {
      hydrateCartUI();
      if (event.action === 'add') resetDrawerScroll();
      requestAnimationFrame(hydrateCartImages);
    });
    setTimeout(hydrateCartImages, 80);

    if (detail?.didError) return;

    const itemCount = Number(cart?.totalQuantity ?? detail?.itemCount);
    if (Number.isFinite(itemCount)) {
      await customElements.whenDefined('cart-icon');
      document.querySelectorAll('cart-icon').forEach((icon) => {
        if (typeof icon.renderCartBubble !== 'function') return;
        if (Number(icon.currentCartCount) !== itemCount) icon.renderCartBubble(itemCount);
      });
    }
  } catch (error) {
    if (error?.name !== 'AbortError') console.warn('[SOLMIRE] Cart UI sync skipped:', error);
  }
}

function onDrawerOpen(event) {
  if (!(event.target instanceof Element) || event.target.id !== 'cart-drawer') return;
  requestAnimationFrame(() => {
    hydrateCartUI();
    neutralizePageSqueeze();
    syncDesktopOverlay();
  });
}

function onDrawerClose(event) {
  if (!(event.target instanceof Element) || event.target.id !== 'cart-drawer') return;
  clearDesktopOverlay();
}

if (!window.__solmireCartBridgeBound) {
  window.__solmireCartBridgeBound = true;
  document.addEventListener(StandardEvents.cartLinesUpdate, syncCartUI);
  document.addEventListener('theme-drawer:open', onDrawerOpen);
  document.addEventListener('theme-drawer:close', onDrawerClose);
  document.addEventListener('shopify:section:load', hydrateCartUI);
  window.addEventListener('pageshow', hydrateCartUI);
  desktopDrawerQuery.addEventListener('change', syncDesktopOverlay);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrateCartUI, { once: true });
  } else {
    hydrateCartUI();
  }
}
